import { BrowserModule, TransferState } from '@angular/platform-browser';
import { LightboxModule } from 'angular2-lightbox';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { app_routing } from './app.routing';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonThemeModule, RavenErrorHandler } from './common-theme/index';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { exportTranslateStaticLoader } from './common-theme/i18n/translate-browser-loader.service';

// Material
import {
  MatInputModule,
  MatDialogModule,
  MatSelectModule,
  MatTooltipModule,
  MatButtonModule,
  MatTabsModule,
  MatIconModule,
  MatCheckboxModule,
  MatRadioModule
} from '@angular/material';

// Shared
import { MenuContainerComponent } from './shared/components/menu/menu-container/menu-container.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { ContactUsComponent } from './shared/components/contact-us/contact-us.component';

// Components
import { ConstructionComponent } from './downtown-life/construction.component';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { LocalisationComponent } from './localisation/localisation.component';
import { InterfaceComponent } from './localisation/interface.component';
import { GmapComponent } from './localisation/gmap.component';
import { DowntownLifeComponent } from './downtown-life/downtown-life.component';
import { OurViewComponent } from './downtown-life/our-view.component';
import { FinishesComponent } from './downtown-life/finishes.component';
import { TechnicalComponent } from './downtown-life/technical.component';
import { FacilitiesComponent } from './downtown-life/facilities.component';
import { GalleryComponent } from './downtown-life/gallery.component';
import { MenuItemComponent } from './shared/components/menu/menu-item/menu-item.component';
import { PartnersComponent } from './partners/partners.component';
import { HousesComponent } from './houses/houses.component';
import { HouseDetailsComponent } from './houses/house-details.component';
import { ApartmentTypeDetailsComponent } from './houses/apartment-type-details.component';
import { HousesRouterComponent } from './houses/houses-router.component';
import { ImagesCarouselComponent } from './shared/components/images-carousel/images-carousel.component';
import { ContactFormComponent } from './shared/components/contact-form/contact-form.component';
import { HomepageCarouselComponent } from './shared/components/homepage-carousel/homepage-carousel.component';

// Services

// Directives
import { PositionAwareCoverDirective } from './shared/directives/position-aware-cover.directive';
import { MyApartmentTypeComponent } from './shared/components/my-apartment-type/my-apartment-type.component';

@NgModule({
  declarations: [
    // Components
    AppComponent,
    HomeComponent,
    ConstructionComponent,
    ContactComponent,
    LocalisationComponent,
    InterfaceComponent,
    GmapComponent,
    DowntownLifeComponent,
    OurViewComponent,
    FinishesComponent,
    TechnicalComponent,
    FacilitiesComponent,
    GalleryComponent,
    MenuItemComponent,
    ContactUsComponent,
    PartnersComponent,
    HousesComponent,
    HouseDetailsComponent,
    ApartmentTypeDetailsComponent,
    HousesRouterComponent,
    ImagesCarouselComponent,
    ContactFormComponent,
    HomepageCarouselComponent,

    // Shared
    MenuContainerComponent,
    FooterComponent,
    MyApartmentTypeComponent,

    // Directives
    PositionAwareCoverDirective
  ],
  imports: [
    CommonThemeModule,
    BrowserModule.withServerTransition({ appId: 'romanescu-park' }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDqK0aUZbZtx31c8Ic6qQOCLctffxhG4Dk',
      libraries: ['places']
    }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: exportTranslateStaticLoader,
        deps: [HttpClient, TransferState]
      }
    }),
    TransferHttpCacheModule,
    FormsModule,
    FlexLayoutModule,
    app_routing,
    BrowserAnimationsModule,
    LightboxModule,
    ScrollToModule.forRoot(),

    // Material
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule,
    MatTabsModule,
    MatIconModule,
    MatCheckboxModule,
    MatRadioModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: RavenErrorHandler }
  ],
  entryComponents: [ ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts